import React, { useContext } from 'react';
import { NationalAccountContext } from '../../../../../contexts';
import { EINInputModal } from './EINInputModal';
import { GovernmentAffiliationWarningModal } from './GovernmentAffiliationModal';
import { ConfirmEnrollModal } from './ConfirmEnrollModal';
import { CodeDetailDescription } from '../commons';

export const EINModalContainer = (): JSX.Element => {
  const { validResponseState, showModal } = useContext(NationalAccountContext);
  return (
    <div
      data-testid="EINModalContainer"
      className="sui-flex sui-flex-col sui-justify-center sui-font-regular sui-text-1xl"
    >
      <CodeDetailDescription
        validResponseState={validResponseState}
        showModal={showModal}
      />
      <ModalBody />
    </div>
  );
};

const ModalBody = (): JSX.Element => {
  const { validResponseState } = useContext(NationalAccountContext);
  if (validResponseState.einGovState) {
    return <GovernmentAffiliationWarningModal />;
  }
  if (validResponseState.requiredEINState) {
    return <EINInputModal />;
  }
  return <ConfirmEnrollModal />;
};
